/**
 * Singleton MSAL PublicClientApplication.
 * Created once at module load; initialize() is called in main.tsx before
 * the React tree renders (required by msal-browser v3+).
 */
import { PublicClientApplication, EventType, type AuthenticationResult } from '@azure/msal-browser'
import { msalConfig } from './msalConfig'

export const msalInstance = new PublicClientApplication(msalConfig)

// Set active account on successful login / acquire so MsalProvider stays in sync.
msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
    event.payload
  ) {
    const payload = event.payload as AuthenticationResult
    if (payload.account) msalInstance.setActiveAccount(payload.account)
  }
})
